export default "__VITE_ASSET__bUZsuxVz__"